'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('./tslib.es6-cd939937.js');
var uaParserJs = require('ua-parser-js');

var Device = /** @class */ (function () {
    function Device() {
        var _this = this;
        this.info = null;
        if (this.isSmartTv()) {
            this.getSmartTvInfo().then(function (info) {
                _this.info = info;
            });
        }
        else {
            var inst = new uaParserJs.UAParser(navigator.userAgent);
            this.info = inst.getResult();
        }
    }
    /* devices */
    /**
     * @method getDeviceType
     * @return {'console|'mobile'|'tablet'|'smarttv'|'wearable'|'embedded'}
     * */
    Device.prototype.getDeviceType = function () {
        return this.info.device.type || 'other';
    };
    Device.prototype.isAnyMobile = function () {
        return (this.isTablet() || this.isMobile() || this.isWearable() || this.isIphone() || this.isIpad());
    };
    Device.prototype.isAppleDevice = function () {
        return this.isIOS() || this.isMacOs() || (this.info.device.vendor && this.info.device.vendor.toLowerCase().indexOf('apple') !== -1);
    };
    Device.prototype.isTablet = function () {
        return (this.info.device.type || '').toLowerCase().indexOf('tablet') !== -1;
    };
    Device.prototype.isMobile = function () {
        return (this.info.device.type || '').toLowerCase().indexOf('mobile') !== -1;
    };
    Device.prototype.isWearable = function () {
        return (this.info.device.type || '').toLowerCase().indexOf('wearable') !== -1;
    };
    Device.prototype.isIpad = function () {
        return (this.info.device.model || '').toLowerCase().indexOf('ipad') !== -1;
    };
    Device.prototype.isIphone = function () {
        return (this.info.device.model || '').toLowerCase().indexOf('iphone') !== -1;
    };
    /** OS */
    Device.prototype.getOsName = function () {
        return this.info.os.name || 'unknown';
    };
    Device.prototype.getOsVersion = function () {
        return this.info.os.version || 'unknown';
    };
    Device.prototype.isSmartTv = function () {
        // @ts-ignore
        return !!window['tizen'] || !!window['webOS'];
    };
    Device.prototype.isTizenOS = function () {
        // @ts-ignore
        return !!window['tizen'] && window['webapis'];
    };
    Device.prototype.isLGWebOS = function () {
        // @ts-ignore
        return !!window['webOS'];
    };
    Device.prototype.isAndroid = function () {
        return (this.info.os.name || '').toLowerCase().indexOf('android') !== -1;
    };
    Device.prototype.isWindows = function () {
        return (this.info.os.name || '').toLowerCase().indexOf('windows') !== -1;
    };
    Device.prototype.isIOS = function () {
        return (this.info.os.name || '').toLowerCase().indexOf('ios') !== -1;
    };
    Device.prototype.isMacOs = function () {
        return (this.info.os.name || '').toLowerCase().indexOf('mac os') !== -1;
    };
    /** browsers */
    Device.prototype.getBrowserName = function () {
        return this.info.browser.name || 'unknown';
    };
    Device.prototype.getBrowserVersion = function () {
        return this.info.browser.version || '0';
    };
    Device.prototype.isIE = function () {
        return (this.info.browser.name || '').toLowerCase().indexOf('ie') !== -1;
    };
    Device.prototype.isEdge = function () {
        return (this.info.browser.name || '').toLowerCase().indexOf('edge') !== -1;
    };
    Device.prototype.isSafari = function () {
        return (this.info.browser.name || '').toLowerCase().indexOf('safari') !== -1;
    };
    Device.prototype.isOpera = function () {
        return (this.info.browser.name || '').toLowerCase().indexOf('opera') !== -1;
    };
    Device.prototype.isFirefox = function () {
        return (this.info.browser.name || '').toLowerCase().indexOf('firefox') !== -1;
    };
    Device.prototype.isChrome = function () {
        return (this.info.browser.name || '').toLowerCase().indexOf('chrome') !== -1;
    };
    /** desktop sizes */
    Device.prototype.isMobileSize = function () {
        return (window.innerWidth < 999);
    };
    Device.prototype.isMobileScreen = function () {
        return (window.innerWidth > 0) && (window.innerWidth < 640);
    };
    Device.prototype.isTabletScreen = function () {
        return (window.innerWidth > 639) && (window.innerWidth < 1024);
    };
    Device.prototype.isDesktopScreen = function () {
        return (window.innerWidth > 1023);
    };
    // others
    Device.prototype.getSmartTvInfo = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            var info, promise, resolver_1;
            var _this = this;
            return tslib_es6.__generator(this, function (_a) {
                info = {
                    browser: {
                        major: null,
                        name: null,
                        version: null,
                    },
                    cpu: {
                        architecture: null,
                    },
                    device: {
                        model: null,
                        type: null,
                        vendor: null,
                    },
                    engine: {
                        name: null,
                        version: null,
                    },
                    os: {
                        name: null,
                        version: null,
                    },
                    ua: null,
                };
                if (this.isLGWebOS()) {
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            // @ts-ignore
                            window['webOS'].deviceInfo(function (device) {
                                info.browser.version = info.os.version = device.version || '1.em';
                                info.browser.name = info.os.name = 'WebOs';
                                info.device.type = 'smarttv';
                                info.device.vendor = 'lg';
                                // info.device.model = (device.modelNameAscii) ? device.modelNameAscii : "";
                                info.device.model = device.modelName || '';
                                [
                                    'sdkVersion',
                                    'versionMajor',
                                    'versionMinor',
                                    'versionDot',
                                    'uhd',
                                    'uhd8K',
                                    'oled',
                                    'ddrSize',
                                    'hdr10',
                                    'dolbyVision',
                                    'dolbyAtmos',
                                    'modelName',
                                    'modelNameAscii',
                                ].map(function (key) {
                                    info[key] = device[key];
                                });
                                // info.sdkVersion = device.sdkVersion;
                                // info.versionMajor = device.versionMajor;
                                // info.versionMinor = device.versionMinor;
                                // info.versionDot = device.versionDot;
                                resolve(info);
                            });
                        })];
                }
                else if (this.isTizenOS()) {
                    promise = void 0;
                    if (document.readyState === 'loading') {
                        resolver_1 = null;
                        promise = new Promise(function (resolve, reject) {
                            resolver_1 = resolve;
                        });
                        window.addEventListener('load', function () {
                            _this.getTizenInfo(info);
                            resolver_1(info);
                        });
                        return [2 /*return*/, promise];
                    }
                    else {
                        this.getTizenInfo(info);
                        return [2 /*return*/, info];
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    Device.prototype.getTizenInfo = function (info) {
        info.browser.name = info.os.name = 'Tizen';
        info.device.type = 'smarttv';
        info.device.vendor = 'samsung';
        // @ts-ignore
        if (window.webapis.productinfo) {
            // @ts-ignore
            info.browser.version = info.os.version = window.webapis.productinfo.getVersion() || '';
            // @ts-ignore
            info.device.model = window.webapis.productinfo.getModel() || '';
            // @ts-ignore
            info.modelCode = window.webapis.productinfo.getModelCode() || '';
        }
        try {
            // @ts-ignore
            if (tizen.systeminfo.getCapability) {
                // @ts-ignore
                info.browser.version = info.os.version = tizen.systeminfo.getCapability('http://tizen.org/feature/platform.version');
                // @ts-ignore
            }
            else if (tizen.systeminfo.getCapabilities) {
                // @ts-ignore
                info.browser.version = info.os.version = tizen.systeminfo.getCapabilities().platformVersion;
            }
        }
        catch (e) {
            info.browser.version = info.os.version = '3'; // minimal supported version
        }
        // @ts-ignore
        info.playerVersion = webapis.avplay && webapis.avplay.getVersion ? webapis.avplay.getVersion() : null;
    };
    Device.prototype.connectionType = function () {
        if (this.isTizenOS()) {
            try {
                // @ts-ignore
                var connectionType = webapis.network.getActiveConnectionType();
                switch (connectionType) {
                    // @ts-ignore
                    case webapis.network.NetworkActiveConnectionType.WIFI:
                        return 'wifi';
                    // @ts-ignore
                    case webapis.network.NetworkActiveConnectionType.ETHERNET:
                        return 'ethernet';
                    // @ts-ignore
                    case webapis.network.NetworkActiveConnectionType.CELLULAR:
                        return 'cellular';
                    // @ts-ignore
                    case webapis.network.NetworkActiveConnectionType.DISCONNECTED:
                    default:
                        return 'unavailable';
                }
            }
            catch (e) {
                console.log(e);
            }
        }
        else if (this.isLGWebOS()) ;
        // if (NetworkProfiling.isInstantiate()) {
        //   netType = NetworkProfiling.instance().getInfo().type;
        // }
        var nav = navigator;
        var connectionInst = (nav.connection || nav.mozConnection || nav.webkitConnection);
        var type = ((connectionInst === null || connectionInst === void 0 ? void 0 : connectionInst.type) || (connectionInst === null || connectionInst === void 0 ? void 0 : connectionInst.effectiveType) || '').toLowerCase();
        return type && type !== 'unknown' ? type : 'unavailable';
    };
    return Device;
}());
var device = new Device();

exports.Device = Device;
exports.device = device;
